import {addQueryToPath} from '../../../libs/shared/core/src/helpers/browser/urlHelpers';
import {LensModel} from '../../models/api/lensModel';
import {InboxesFiltersEnum} from '../../models/url/models/inboxesUrlModel';

interface SearchLensOptions {
  namespace?: string;
  /** Only list lenses after the offset. */
  offset?: number;
  /** Limits the number of lenses returned in the response. */
  limit?: number;
}

export function buildLensSearchUrl(companyUrl: string, query: string, options: SearchLensOptions) {
  const route = options.namespace ? `namespaces/${options.namespace}/search_lens` : 'search_lens';

  return addQueryToPath(`${companyUrl}/${route}/${encodeURIComponent(query.toLowerCase())}`, {
    offset: options.offset ?? 0,
    limit: options.limit ?? 50,
  });
}

export function isAiReviewLens(lens: LensModel) {
  return lens.name.startsWith('[AI review]');
}

export function buildAiReviewLensPath(lensId: number) {
  // Order matters to make sure the lens will be displayed as selected in P1.
  // See `makeGetIsSelected` in `src/components/inboxes/workspaces/workspaceItemContainerHelpers.ts`.
  const filters = [
    InboxesFiltersEnum.ARCHIVED,
    InboxesFiltersEnum.ASSIGNED,
    InboxesFiltersEnum.SNOOZED,
    InboxesFiltersEnum.UNASSIGNED,
  ];

  return `/inboxes/teams/saved-views/${lensId}/${filters.join(',')}`;
}
